class LightboxPicture {
    constructor() {
        this.lightboxPicture = document.querySelector('.js-lightbox-picture');
        if (this.lightboxPicture) {
            this.lightboxPicture.addEventListener('click', () => {
                this.lightboxPicture.querySelector('img').src = null;
                this.lightboxPicture.classList.add('hidden');
            });
            document.querySelectorAll('.main img:not(.disable-lightbox)').forEach((picture) => {
                picture.classList.add('cursor-pointer');
                this.bindPicture(picture);
            });
        }
    }

    bindPicture(picture) {
        picture.addEventListener('click', () => {
            this.lightboxPicture.querySelector('img').src = picture.src;
            this.lightboxPicture.classList.remove('hidden');
        });
    }
}

export default LightboxPicture;
